import type { components } from "@/api-schema";
import { cn } from "@/common/helpers/utils";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useTranslation } from "react-i18next";
import { HISTORY_COLUMNS } from "./vehicle-valuation-history-columns";

type VehicleValuation = components["schemas"]["VehicleValuation"];

interface VehicleValuationHistoryTableProps {
  entries: VehicleValuation[];
}

export function VehicleValuationHistoryTable({ entries }: VehicleValuationHistoryTableProps) {
  const { t } = useTranslation("fab");

  return (
    <Table>
      <TableHeader className="[&_tr]:border-0">
        <TableRow className="text-xs font-normal">
          {HISTORY_COLUMNS.map((col) => (
            <TableHead
              key={col.headerKey}
              className={cn(
                "h-auto border-0 bg-transparent py-1 align-bottom normal-case",
                col.align === "right" && "text-right",
                col.hiddenOnMobile && "hidden sm:table-cell",
              )}
            >
              {t(col.headerKey)}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {entries.map((entry) => (
          <TableRow key={entry.uuid} className="border-0">
            {HISTORY_COLUMNS.map((col) => (
              <TableCell
                key={col.headerKey}
                className={cn(
                  "py-1 tabular-nums",
                  col.align === "right" && "text-right",
                  col.hiddenOnMobile && "hidden sm:table-cell",
                )}
              >
                {col.render(entry)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
